import isEqual from 'lodash/isEqual';
import { BrandAffinityInsightData } from 'modules/intelligentInsights/brandAffinityInsights/types';
import { defaultCoreContext } from './CoreContext';

export const isDefaultCoreData = (coreData: BrandAffinityInsightData) => {
  return isEqual(coreData, defaultCoreContext.insightsData);
};
